import React, { useState } from "react";

// Component Imports
import EmailModal from "../../../../../Components/EmailModal";
import EmailEditorTinyMce from "../../../../../Components/EmailEditor/EmailEditorTinyMce";

// MUI Imports
import TextField from "@mui/material/TextField";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import CloseIcon from "@mui/icons-material/Close";

// Helper Functions
import { formatDate } from "../../../../../Helpers/formatters";
import DOMPurify from 'dompurify';

const EmailLogsRow = ({
  row,
  index,
  allCustomerData,
  setUpdatedData,
  setTrigger,
}) => {

  const [emailModalIsOpen, setEmailModalisOpen] = useState(false);
  const {
    userDetailsInfo: { brandId, customerId, campaignId },
  } = allCustomerData;

  const { category, email, subject, status, sentDate } = row;
  const [toEmail, setToEmail] = useState("");
  const [emailSubject, setSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");
  
  const setCurrentEditor= (currentRow) => {    
    const { body, email, subject } = currentRow;
    setToEmail(email);
    setSubject(subject);
    setEmailBody(body);
    setEmailModalisOpen(true);
  };

  const supportBrand = (brand) => {
    switch (brand) {
      case 1:
        return "kidslivesafe.com";
      case 2:
        return "spyfly.com";
      case 3:
        return "publicdatacheck.com";
      case 4:
        return "publicinformationservices.com";
      case 5:
        return "searchpublicrecords.com";
      case 6:
        return "publicrecordreports.com";
      case 7:
        return "quickpublicrecords.com";
      case 8:
        return "propertyfocus.com";
      default:
        return;
    }
  };

  const sendEmail = async () => {
    const emailData = {
      To: toEmail,
      Subject: emailSubject,
      CampaignId: campaignId,
      Body: encodeURI(DOMPurify.sanitize(emailBody)),
      EmailType: category,
    };
    const options = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(emailData),
    };
    const res = await fetch(`/api/customer/${customerId}/send-email`, options);
    const { success, message } = await res.json();
    setUpdatedData((prevState) => ({
      updateData: {
        ...prevState.updateData,
        state: success ? true : false,
        message: success ? "Email Sent Successfully" : message,
      },
    }));
    setTrigger("UPDATE_EMAILS");
    setTrigger("");
    setEmailModalisOpen(false);
  };

  return (
    <>
      <EmailModal
        open={emailModalIsOpen}
        handleClose={() => setEmailModalisOpen(false)}
      >
        <div className="modal-header">
          <h2 style={{ padding: ".5rem", color: "#389fe8" }}>Send Email</h2>
          <button className="send-program-cta" onClick={sendEmail}>
            <span>Send</span>
          </button>
          <div>
            <CloseIcon
              className="close-icons"
              onClick={() => {setEmailModalisOpen(false)}}
            />
          </div>
        </div>
        <TextField
          id="outlined-full-width"
          className="input-el"
          label={"To"}
          type="text"
          style={{ margin: 3, width: "30%" }}
          fullWidth={false}
          margin="normal"
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          value={toEmail}
          onChange={(e) => setToEmail(e.target.value)}
        />
        <TextField
          id="outlined-full-width"
          className="input-el"
          label={"From"}
          type="text"
          style={{ margin: 3, width: "31%" }}
          fullWidth={false}
          margin="normal"
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          value={`support@${supportBrand(brandId)}`}
          disabled={true}
        />
        <TextField
          id="outlined-full-width"
          className="input-el"
          label={"Subject"}
          type="text"
          style={{ margin: 3, width: "26%" }}
          fullWidth={false}
          margin="normal"
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          value={emailSubject}
          onChange={(e) => setSubject(e.target.value)}
        />
        <EmailEditorTinyMce emailData={row} setEmailBody={setEmailBody} />
      </EmailModal>
      <TableRow key={index}>
        <TableCell className="tableCell" align="center">
          {email}
        </TableCell>
        <TableCell className="tableCell" align="center">
          {subject}
        </TableCell>
        <TableCell className="tableCell" align="center">
          {formatDate(sentDate)}
        </TableCell>
        <TableCell className="tableCell" align="center">
          {status}
        </TableCell>
        <TableCell className="tableCell" align="center">
          <button
            className="vs-email-btn"
            onClick={() => setCurrentEditor(row)}
          >
            <span>View and Send</span>
          </button>
        </TableCell>
      </TableRow>
    </>
  );
};

export default EmailLogsRow;
